import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import ParkProposition from 'components/sales/formSection/parkProposition/parkProposition';
import { handleValidateObj } from 'constants/objValues/objvalues';

const OtherDetail = ({ locationCity, cities, dropDownData, handleValue }) => {
  const [formData, setData] = useState({
    app_available: '',
    no_of_cities: '',
  });
  const [isRequired, setRequired] = useState(false);
  const [partnership, setPartnership] = useState([]);

  const handleParkProposition = (val) => {
    if (val !== null && val !== undefined && val !== '') {
      setRequired(false);
      if (partnership.length === 0) {
        partnership.push(val.scope_of_partnership);
        setPartnership(partnership);
      } else {
        const findIndex = partnership.findIndex(
          (obj) => obj === val.scope_of_partnership
        );
        if (findIndex === -1) {
          partnership.push(val.scope_of_partnership);
          setPartnership([...partnership]);
        } else {
          partnership.splice(findIndex, 1);
          partnership.push(val.scope_of_partnership);
          setPartnership([...partnership]);
        }
      }
      setData({ ...formData, scope_of_partnership: partnership });
    } else {
      setRequired(true);
      setData({ ...formData, scope_of_partnership: '' });
    }
  };
  const handleSubmitData = () => {
    const isNotEmpty = handleValidateObj(formData);
    if (isNotEmpty !== false) {
      handleValue({
        ...formData,
        no_of_cities: [formData.no_of_cities],
      });
    }
  };

  useEffect(() => {
    (async () => {
      await locationCity();
    })();
  }, []);

  useEffect(() => {
    handleSubmitData();
  }, [formData]);

  return (
    <FormSection title={localization.otherDetail}>
      <DropDownInput
        label={localization.appAvail}
        inputValue={formData.appAvail}
        data={dropDownData.appAvailaible}
        type="text"
        getIdValue={(value) =>
          setData({ ...formData, app_available: value.id })
        }
        errorMsg={localization.isRequired}
        required
        isStarRequired={true}
      />

      <DropDownInput
        label={localization.cities}
        data={cities}
        errorMsg={localization.isRequired}
        inputValue={formData.no_of_cities}
        type="text"
        getIdValue={(value) =>
          setData({ ...formData, no_of_cities: value.value })
        }
        required
        isStarRequired={true}
      />
      <h4 className="w-100">{localization.scopeOfPartnership}</h4>
      {dropDownData.scopeOfPartnership &&
        dropDownData.scopeOfPartnership.map((item) => {
          return (
            <div className="w-100" key={item.id}>
              <div className="d-inline-block">
                <ParkProposition
                  key={item.id}
                  label={item.name}
                  item={item}
                  handleValue={handleParkProposition}
                />
              </div>
            </div>
          );
        })}
      {isRequired === true ? (
        <span className="checkbox-required error">
          {localization.enterField}
        </span>
      ) : null}
    </FormSection>
  );
};

OtherDetail.propTypes = {};

export default OtherDetail;
